import {masonryInit} from './postgrid';
import $ from 'jquery';

function initSearch() {

    $(document).ready(function () {
        // msnry = returnMsnry();
        // //console.log('init search');


    });

    $(".asp_main_container").on("asp_search_start", function (event, id, instance, phrase) {
        $("body").addClass("initMsnry");
        // //console.log(id, instance, phrase);

    });

    $(window).on('pub:XHR:loaded', function () {
        masonryInit()
    })


}


export default initSearch


